export default {
    multi: {
        "bowling-alley": "Tory do kręgli",
        "sports-hall-sector": "Sektory hali sportowej",
        "squash-court": "Korty do gry w Squasha",
        "tennis-court": "Korty tenisowe",
        "sport-field-sector": "Sektory boiska",
        "gym": 'Sala gimnastyczna'
    },
}